import type { ThemeMode } from '@store/appConfig/types';

import type { PaletteColorOptions } from '@mui/material';

export type Palette = {
  primary?: string;
} & string[];

export type PalettesProperties = Record<string, Palette>;

const lightModeGreyColors = {
  grey: [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#1c4d5c',
    '#141414',
    '#000000',
    '#fafafa',
    '#bfbfbf',
    '#434343',
    '#1f1f1f',
    '#fafafb',
    '#e6ebf1',
    '#eff2f4',
  ],
};

const darkModeGreyColors = {
  grey: [
    '#000000',
    '#141414',
    '#1e1e1e',
    '#595959',
    '#8c8c8c',
    '#bfbfbf',
    '#d9d9d9',
    '#f0f0f0',
    '#f5f5f5',
    '#fafafa',
    '#ffffff',
    '#fafafa',
    '#bfbfbf',
    '#434343',
    '#1f1f1f',
    '#121212',
    '#d3d8db',
    '#1e1e1e',
  ],
};

export const getGreyColors = (
  mode: ThemeMode
): Required<PaletteColorOptions> => {
  const colors: PalettesProperties =
    mode === 'dark' ? darkModeGreyColors : lightModeGreyColors;
  const { grey } = colors;

  const greyColors: Required<PaletteColorOptions> = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16],
    A900: grey[17],
  };

  return greyColors;
};
